import React from 'react';
import Icon from '../../../components/AppIcon';
import { useCompany } from '../../../components/context/CompanyContext';
import { formatItemPrice, isRangePriced } from '../../../utils/pricingUtils';


const BookingSummaryPanel = ({ selectedDate, selectedSlot, service }) => {
  const { company } = useCompany();

  const formatDate = (date) => {
    if (!date) return '';
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(date)?.toLocaleDateString('en-US', options);
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-xl p-4 md:p-6 lg:p-8 border border-primary/20">
      <h3 className="font-heading font-semibold text-lg md:text-xl lg:text-2xl text-foreground mb-4 md:mb-6">
        Booking Summary
      </h3>
      <div className="space-y-4 md:space-y-5 lg:space-y-6">
        <div className="flex items-start gap-3 md:gap-4">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">Selected Date</p>
            <p className="font-caption font-medium text-sm md:text-base lg:text-lg text-foreground">
              {selectedDate ? formatDate(selectedDate) : 'Not selected'}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3 md:gap-4">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Clock" size={20} color="var(--color-secondary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">Selected Time</p>
            <p className="font-caption font-medium text-sm md:text-base lg:text-lg text-foreground">
              {selectedSlot ? selectedSlot?.time : 'Not selected'}
            </p>
          </div>
        </div>

        {selectedSlot && (
          <>
            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="Timer" size={20} color="var(--color-accent)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">Duration</p>
                <p className="font-caption font-medium text-sm md:text-base lg:text-lg text-foreground">
                  {selectedSlot?.duration} minutes
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name="ReceiptCent" size={20} color="var(--color-success)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
                  {isRangePriced(service) ? 'Price range' : 'Estimated Price'}
                </p>
                <p className="font-heading font-semibold text-lg md:text-xl lg:text-2xl text-foreground">
                  {formatItemPrice(service)}
                </p>
                {isRangePriced(service) && (
                  <p className="mt-1 text-xs text-muted-foreground font-caption">The business will confirm the final price before payment.</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {selectedSlot && (
        <div className="mt-6 md:mt-8 p-3 md:p-4 bg-card rounded-lg border border-border">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <p className="text-xs md:text-sm font-caption text-muted-foreground">
            Your appointment slot will be held for {company?.bookingRules?.slotHoldingTime || 10} minutes while you complete your booking details.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingSummaryPanel;
